import {
    GetRouteAdTargeting,
    PageType,
    publicationAdKind,
    TogglesReduxState,
    AdTargeting,
} from '@news-mono/web-common'
import {
    ArticleLikeV4DTO,
    PageMetaDTO,
} from '@west-australian-newspapers/publication-types'
import { layout } from '../../../App.routing'
import { getNoIndexMeta } from './allowList'
import { toFeatureState } from '@west-australian-newspapers/etrigan-feature-toggles-client'
import { TheWestSection } from '@news-mono/common'
import { metrics } from '@news-mono/component-library'

export const createShorthandRoute = ({
    article,
    section,
    getAdTargeting,
    pageMeta,
    toggles,
}: {
    article: ArticleLikeV4DTO
    section: TheWestSection
    getAdTargeting: GetRouteAdTargeting
    pageMeta?: PageMetaDTO
    toggles?: TogglesReduxState
}): PageType<TheWestSection> => {
    const featureState = toggles && toFeatureState(toggles)

    const { adUnitPath, ssAdUnits, topics } = getAdTargeting(
        publicationAdKind[article.kind],
        section,
        article.topics.primary,
        ...article.topics.secondary,
    )

    const adTargeting: AdTargeting = {
        pageId: article.slug,
        adUnitPath,
        ssAdUnits,
        topics,
    }

    return {
        kind: 'page',
        heading: article.heading,
        pageMeta: {
            ...pageMeta,
            description: article.homepageTeaser,
            meta: getNoIndexMeta(article.source, section, featureState),
        },
        socialMeta: {
            title: article.socialHead || article.homepageHead,
            description: article.socialTeaser || article.homepageTeaser,
        },
        hideHeading: true,
        noMetaTitleTemplate: false,
        pageType: 'publication',
        adTargeting,
        additionalPageProperties: {
            publicationKind: 'shorthand-publication',
            hasTopGutter: false,
            hasBottomGutter: false,
            requiredAccess: article.requiredAccess,
        },
        section,
        compositions: [
            layout.composition({
                type: 'box',
                props: {},
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'shorthand-breach-composition',
                            props: {
                                requiredAccess: article.requiredAccess,
                                article,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'shorthand-publication',
                                        props: {
                                            meta: {
                                                slug: article.slug,
                                                kind: 'article',
                                                inlinePublicationContent: [],
                                            },
                                            dataDefinitionArgs: {
                                                publicationId: article.id,
                                            },
                                            section,
                                        },
                                    }),
                                ],
                                breach: [
                                    layout.nestedComposition({
                                        type: 'box',
                                        props: {
                                            hasTopSpacing: true,
                                            containerWidth:
                                                metrics.thewest
                                                    .featureContentWidth,
                                            hasBackgroundFill: true,
                                            verticalSpacing: 'md',
                                            horizontalGutters: 'md',
                                        },
                                        contentAreas: {
                                            main: [
                                                layout.component({
                                                    type: 'topic-list',
                                                    props: {
                                                        topics: article.topics,
                                                        verticalSpacing: 'sm',
                                                    },
                                                }),
                                                layout.component({
                                                    type: 'headline',
                                                    props: {
                                                        text: article.heading,
                                                    },
                                                }),
                                                layout.nestedComposition({
                                                    type: 'box',
                                                    props: {
                                                        hasTopSpacing: true,
                                                        hasBackgroundFill: true,
                                                        verticalSpacing: 'md',
                                                    },
                                                    contentAreas: {
                                                        main: [
                                                            layout.component({
                                                                type: 'breachscreen',
                                                                props: {
                                                                    breachwall:
                                                                        'default',
                                                                    title: 'Subscribe to view this article',
                                                                    breachDeal:
                                                                        'Shorthand',
                                                                    breachType:
                                                                        'default-2026',
                                                                    breachCreativeName:
                                                                        'default',
                                                                    section:
                                                                        'default',
                                                                },
                                                            }),
                                                        ],
                                                    },
                                                }),
                                            ],
                                        },
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}
